import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { thousandSeparator } from '../reqs-filter/utils';

export const selectAutoparksTransportsDomain = state => state.autoparksTransportsReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getAutoparksTransportsSelector = () =>
	createSelector(selectAutoparksTransportsDomain, ({ autoparksTransports }) => {
		return autoparksTransports.map(transport => {
			return {
				...transport,
				weight: thousandSeparator(transport.weight),
				volume: thousandSeparator(transport.volume),
				count: thousandSeparator(transport.count),
			};
		});
	});

export const getAutoparksTransportsAllowSelector = () =>
	createSelector(selectAutoparksTransportsDomain, ({ autoparksTransports }) => {
		return autoparksTransports.map(item => ({
			...item,
		}));
	});

export const getIsAutoparksTransportsLoadingSelector = () =>
	createSelector(selectAutoparksTransportsDomain, ({ isAutoparksTransportsLoading }) => isAutoparksTransportsLoading);

export const getRawPaginationSelector = () =>
	createSelector(selectAutoparksTransportsDomain, ({ pagination }) => pagination);

export const getPaginationSelector = () =>
	createSelector(selectAutoparksTransportsDomain, ({ pagination }) => {
		if (!pagination) {
			return { totalPages: 1 };
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
